import Vue from 'vue'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  scheduleTypes: []
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  scheduleTypes: state => state.scheduleTypes
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  refresh: (state, { scheduleTypes }) => {
    state.scheduleTypes = scheduleTypes
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async refresh({ commit }) {
    const scheduleTypes = await Vue.$api.scheduleType.fetch()
    commit('refresh', { scheduleTypes })
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
